import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BlurredAztecCode } from '../../../atoms/BlurredAztecCode/BlurredAztecCode';

import {
	MplDeutschlandTicketCardFooter,
	MplDeutschlandTicketCardHeader,
	MplDeutschlandTicketCardSeparator,
	MplDeutschlandTicketNameAndStatus,
	StyledBottomContainer,
	StyledCardContainer,
	StyledTicketContainer,
	StyledTicketDetailsSection,
} from './components';

interface IMplDeutschlandTicketCardInvalidProps {
	firstName: string;
	lastName: string;
	formattedPrice: string;
	ticketId: string;
}

export const MplDeutschlandTicketCardInvalid: FC<
	IMplDeutschlandTicketCardInvalidProps
> = ({ firstName, lastName, formattedPrice, ticketId }) => {
	const { t } = useTranslation('userDTicket');
	return (
		<StyledTicketContainer>
			<StyledCardContainer>
				<MplDeutschlandTicketCardHeader formattedPrice={formattedPrice} />
				<MplDeutschlandTicketCardSeparator />
				<StyledBottomContainer>
					<StyledTicketDetailsSection>
						<MplDeutschlandTicketNameAndStatus
							firstName={firstName}
							lastName={lastName}
							statusText={t('dticket_large.status.invalid')}
							statusVariant="error"
						/>
					</StyledTicketDetailsSection>
					<BlurredAztecCode />
					<MplDeutschlandTicketCardFooter ticketId={ticketId} isBlurred />
				</StyledBottomContainer>
			</StyledCardContainer>
		</StyledTicketContainer>
	);
};
